<template>
  <div class="tabs-template">
    <div class="tabs-container">
      <div class="tabs">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{ 'active': activeTab === index }"
          class="tab"
          @click="selectTab(index)"
        >
          {{ $i18nPresenter.t(tab.name) }}
        </div>
      </div>
      <aha-icon
        name="close"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        class="tab__close-button"
        @click="onCloseButtonClicked()"
      />
    </div>
    <div class="tab-content">
      <component :is="tabs[activeTab].component"></component>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    defaultActiveTab: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeTab: this.defaultActiveTab,
    }
  },
  methods: {
    selectTab(index) {
      this.$nextTick(() => {
        if (index !== undefined && index >= 0 && index < this.tabs.length) {
          this.activeTab = index
        } else {
          this.activeTab = this.defaultActiveTab
        }
      })
    },

    onCloseButtonClicked() {
      this.$emit('onCloseButtonClicked')
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs-template {
  @apply fixed top-0 z-10 bg-base-0;
  @apply px-4 rounded-tl-lg rounded-tr-lg;
  @apply w-full h-full;
  .tabs-container {
    @apply flex items-center justify-between;
    @apply border-b border-base-30;
    @apply font-bold text-base text-secondary-100;
    height: 55px;
    box-shadow: 0px 10px 38px 0px #525F7F08;
    .tabs {
      @apply h-full flex items-center gap-5;
    }
  }
  .tab {
    @apply h-full pt-3 cursor-pointer;
    &.active {
      @apply border-b-2 border-primary-90 text-primary-90;
    }
    &:hover {
      @apply text-primary-90;
    }
  }
  .tab-content {
    @apply h-full;
    &::v-deep {
      .ai-controller {
        @apply px-0 mt-0;
        position: unset;
      }
      .ai-improve-panel__content {
        @apply px-0 pt-6 mt-0;
      }
    }
  }
  .tab__close-button {
    @apply text-base-70 hover:text-primary-90;
    @apply cursor-pointer h-full;
  }
}
</style>
